import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Studio from "@/pages/Studio";
import Expertises from "@/pages/Expertises";
import CreationSites from "@/pages/CreationSites";
import SeoLocal from "@/pages/SeoLocal";
import Secteurs from "@/pages/Secteurs";
import Realisations from "@/pages/Realisations";
import ProjectDetail from "@/pages/ProjectDetail";
import Tarifs from "@/pages/Tarifs";
import Diagnostic from "@/pages/Diagnostic";
import Contact from "@/pages/Contact";
import { MentionsLegales, Confidentialite } from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/expertises" element={<Expertises />} />
          <Route path="/expertises/creation-site-internet" element={<CreationSites />} />
          <Route path="/referencement-local-toulouse" element={<SeoLocal />} />
          <Route path="/secteurs" element={<Secteurs />} />
          <Route path="/realisations" element={<Realisations />} />
          <Route path="/realisations/:slug" element={<ProjectDetail />} />
          <Route path="/tarifs" element={<Tarifs />} />
          <Route path="/diagnostic" element={<Diagnostic />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-de-confidentialite" element={<Confidentialite />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/admin/connexion" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}
